<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <!-- contents_head -->
            <!-- breadcrumbs -->
            <fragment v-if="$route.name !== 'newQuestionConnect'">
                <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            </fragment>
            <!-- //breadcrumbs -->
            <h2 class="pg_title" v-if="$route.name === 'newQuestionConnect'">{{ $t('TITLE.CREATE.NEW.QUESTION') }}</h2>
            <h2 class="pg_title" v-else>{{ pageTitle }}</h2>
            <!-- //contents_head -->

            <!-- srchTop_wrap -->
            <div class="srchTop_wrap srchFaq_wrap extend">
                <article class="srch_basic">
                    <dl class="dl_search set_2" v-if="'C550' === corpCd || 'WA' === corpCd">
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('BUTTON.GLOBAL.SEARCH')"
                                v-model="searchTitle"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('FIELD.GLOBAL.SEARCHKEYWORD')"
                                v-model="searchKeyword"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="search(1)">{{
                                $t('BUTTON.GLOBAL.SEARCH')
                            }}</a>
                        </dd>
                    </dl>
                    <dl class="dl_search" v-else>
                        <dd class="clearable" data-input-type="input">
                            <input
                                type="text"
                                class="text_input w100p"
                                :placeholder="$t('BUTTON.GLOBAL.SEARCH')"
                                v-model="searchTitle"
                                @keyup.enter.stop="search(1)"
                                v-clearable
                            />
                        </dd>
                        <dd class="btn">
                            <a href="javascript:" class="btn_srch" @click="search(1)">{{
                                $t('BUTTON.GLOBAL.SEARCH')
                            }}</a>
                        </dd>
                    </dl>
                    <div class="top_mobile">
                        <div class="mobile_title">{{ $t('FIELD.GLOBAL.CATEGORY') }}</div>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" v-model="category1Code" @change="categoryList(2)">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option
                                        v-for="item in category1CodeList"
                                        :key="faqPageName + item.code"
                                        :value="item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </dd>
                        </dl>
                        <dl class="dl_select">
                            <dd data-input-type="select">
                                <select class="slt_white w100p" v-model="category2Code" @change="categoryList(3)">
                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                    <option
                                        v-for="item in category2CodeList"
                                        :key="faqPageName + item.code"
                                        :value="item.code"
                                    >
                                        {{ item.codeName }}
                                    </option>
                                </select>
                            </dd>
                        </dl>
                    </div>
                </article>
                <article class="srch_detail">
                    <!-- mobile -->
                    <div class="list_wrap">
                        <header>
                            <h3>{{ $t('FIELD.FAQ.CATEGORY.QUICK') }}</h3>
                        </header>
                        <ul class="ul_list">
                            <li
                                v-for="item in supportSnb.faqQuickCategoryLAist"
                                :key="faqPageName + item.WORK_KEY_1 + item.WORK_KEY_2 + item.WORK_KEY_3 + item.ROW_NUM"
                            >
                                <a
                                    href="javascript:"
                                    @click="getQuickCategoryClick(item.WORK_KEY_1, item.WORK_KEY_2, item.WORK_KEY_3)"
                                >
                                    {{ getQuickName(item.WORK_KEY_1_NM, item.WORK_KEY_2_NM, item.WORK_KEY_3_NM) }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <dl class="dl_input" v-show="open">
                        <dt>{{ $t('FIELD.GLOBAL.DATE') }}</dt>
                        <dd data-input-type="date">
                            <fieldset class="ui_fieldset">
                                <span class="date-wrap">
                                    <label>
                                        <input
                                            id="frDate"
                                            type="text"
                                            class="date_input w100p"
                                            placeholder="MM.DD.YYYY"
                                            readonly maxlength="20"
                                        />
                                        <a href="javascript:" class="in_btn" id="icoFrDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                        </a>
                                    </label>
                                    <div class="fr_datepicker" id="fr-picker-container" />
                                </span>
                                <em class="txt_space"></em>
                                <span class="date-wrap">
                                    <label>
                                        <input
                                            id="toDate"
                                            type="text"
                                            class="date_input w100p"
                                            placeholder="MM.DD.YYYY"
                                            readonly maxlength="20"
                                        />
                                        <a href="javascript:" class="in_btn" id="icoToDate">
                                            <i class="ico_date"></i>
                                            <span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span>
                                        </a>
                                    </label>
                                    <div class="to_datepicker" id="to-picker-container" />
                                </span>
                            </fieldset>
                        </dd>
                    </dl>
                </article>
                <a href="javascript:" class="btn_ico_srchBtm" title="Fold" @click="srchBtmClick($event)">
                    <span class="sr_only"></span>
                </a>
            </div>

            <!-- mobile_hide -->
            <div class="inquiry_wrap">
                <ul class="ul_list list_03">
                    <li
                        :class="getSnbClass(item.INQUIRY_TYPE1)"
                        v-for="(item, idx) in supportSnb.faqInquiry"
                        :key="qnaPageName + item.INQUIRY_TYPE1 + idx + 'mobile'"
                    >
                        <a href="javascript:" @click="snbClick($event, item.INQUIRY_TYPE1, '', '')">
                            {{ item.INQUIRY_TYPE_NM1 }}<em v-if="item.TOTAL_CNT">({{ item.TOTAL_CNT }})</em>
                        </a>
                        <a
                            href="javascript:"
                            class="ico_arrow"
                            @click="snbClick($event, item.INQUIRY_TYPE1, '', 'arrow')"
                            v-if="!('ALL' === item.INQUIRY_TYPE1 || 'ETC' === item.INQUIRY_TYPE1)"
                        >
                            <span class="sr_only"></span>
                        </a>
                        <ul v-if="!('ALL' === item.INQUIRY_TYPE1 || 'ETC' === item.INQUIRY_TYPE1)">
                            <li
                                v-for="(itemSub, idxSub) in supportSnb.faqSubInquiry"
                                @click="snbClick($event, item.INQUIRY_TYPE1, itemSub.INQUIRY_TYPE2, '')"
                                :key="qnaPageName + itemSub.INQUIRY_TYPE1 + idxSub + 'mobile'"
                            >
                                <a href="javascript:">
                                    {{ itemSub.INQUIRY_TYPE_NM2 }}
                                    <em v-if="itemSub.TOTAL_CNT">({{ itemSub.TOTAL_CNT }})</em>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <!-- //mobile_hide -->

            <!-- faq_wrap -->
            <div class="tab_wrap">
                <div class="tab_btn" v-if="$route.name === 'newQuestionConnect'">
                    <em class="em_info" v-show="!viewYn">{{ $t('MESSAGE.DATA.NEWQUESTION.CONFIRM') }}</em>
                    <a
                        href="javascript:"
                        class="txt_link"
                        @click="createNewQuestionPopup()"
                        v-if="
                            !getIsMobile &&
                                searchYn &&
                                ((0 === qnaTotalRecords && 0 === faqTotalRecords && searchYn) || viewYn)
                        "
                    >
                        {{ $t('MESSAGE.FAQ.CREATE') }}
                    </a>
                </div>
                <div class="tab_btn" v-else>
                    <em class="em_info" v-if="isSurvey">{{ $t('MESSAGE.DATA.NOTQUESTION.CONFIRM') }}</em>
                    <em class="em_info" v-else v-show="!viewYn">{{ $t('MESSAGE.DATA.NEWQUESTION.CONFIRM') }}</em>
                    <a
                        href="javascript:"
                        class="txt_link"
                        @click="register()"
                        v-if="
                            !getIsMobile &&
                                searchYn &&
                                ((0 === qnaTotalRecords && 0 === faqTotalRecords && searchYn) || viewYn)
                        "
                    >
                        {{ $t('MESSAGE.FAQ.CREATE') }}
                    </a>
                </div>

                <ul class="tab_menu_04 tab_menus">
                    <li class="on" id="tab_faq" @click="tabClick($event, 'faq')">
                        <a href="javascript:">
                            {{ $t('FIELD.GLOBAL.FAQ') }}
                            <em class="count">({{ faqTotalRecords === -1 ? 0 : faqTotalRecords }})</em>
                        </a>
                    </li>
                    <li id="tab_qna" @click="tabClick($event, 'qna')">
                        <a href="javascript:">
                            {{ $t('FIELD.GLOBAL.QNA') }}
                            <em class="count">({{ qnaTotalRecords === -1 ? 0 : qnaTotalRecords }})</em>
                        </a>
                    </li>
                </ul>
                <div class="tab_contents">
                    <div class="tab_cont faq">
                        <div class="faq_wrap" v-if="0 < faqList.length">
                            <ul class="faq_list">
                                <li
                                    :class="item.GRADE === 'S' ? 'important' : ''"
                                    :key="faqPageName + item.FAQ_ID"
                                    v-for="item in faqList"
                                >
                                    <div class="ico_faq_q" @click="faqClick($event, item.FAQ_ID)">
                                        <em class="textcolor_important" v-if="'S' === item.GRADE">
                                            [{{ $t('FIELD.GLOBAL.IMPORTANT') }}]
                                        </em>
                                        {{ item.TITLE }}
                                    </div>
                                    <div class="ico_faq_a">
                                        <div class="q_cont">
                                            <div class="namo_scrollbar" v-html="stripHtml(item.QUESTION_DESC)"></div>
                                        </div>
                                        <div class="a_cont" v-if="item.SOLUTION_DESC">
                                            <div class="namo_scrollbar" v-html="stripHtml(item.SOLUTION_DESC)"></div>
                                            <span
                                                v-for="file in faqAttach"
                                                :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"
                                            >
                                                <br />
                                                <a
                                                    :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                    download="true"
                                                    target="_blank"
                                                    class="txt_link"
                                                >
                                                    {{ file.FILE_NM }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="btn_wrap" v-if="$route.name !== 'newQuestionConnect'">
                                <a
                                    href="javascript:"
                                    class="btn_laodmore"
                                    @click="search(0)"
                                    v-if="faqCurrentRecords < faqTotalRecords"
                                >
                                    {{ $t('BUTTON.SEARCH.LOAD.MORE') }}
                                    <em>
                                        (<i>{{ faqCurrentRecords }}</i> / {{ faqTotalRecords }})
                                    </em>
                                </a>
                                <a
                                    href="javascript:"
                                    class="txt_link"
                                    @click="register()"
                                    v-if="!getIsMobile && searchYn && ((0 === faqTotalRecords && searchYn) || viewYn)"
                                >
                                    {{ $t('MESSAGE.FAQ.CREATE') }}
                                </a>
                            </div>
                        </div>
                        <div class="faq_wrap" v-else>
                            <ul class="faq_list">
                                <li class="nodata">
                                    <span>{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="tab_cont qna">
                        <div class="faq_wrap" v-if="0 < qnaList.length">
                            <ul class="faq_list">
                                <li
                                    :class="item.GRADE === 'S' ? 'important' : ''"
                                    :key="qnaPageName + item.QUESTION_ID"
                                    v-for="item in qnaList"
                                >
                                    <div class="ico_faq_q" @click="qnaClick($event, item.QUESTION_ID)">
                                        <em class="textcolor_important" v-if="'Y' === item.URGENT_YN">
                                            [{{ $t('FIELD.GLOBAL.IMPORTANT') }}]
                                        </em>
                                        {{ item.TITLE }}
                                    </div>
                                    <div class="ico_faq_a">
                                        <div class="q_cont">
                                            <div class="namo_scrollbar" v-html="stripHtml(item.QUESTION_DESC)"></div>
                                        </div>

                                        <div class="a_cont" v-if="item.SOLUTION_DESC">
                                            <div class="namo_scrollbar" v-html="stripHtml(item.SOLUTION_DESC)"></div>
                                            <span
                                                v-for="file in qnaAttach"
                                                :key="file.ENC_ATTCH_FILE_SEQ + file.ENC_TOKEN"
                                            >
                                                <br />
                                                <a
                                                    :href="getDownloadUrl(file.ENC_ATTCH_FILE_SEQ, file.ENC_TOKEN)"
                                                    download="true"
                                                    target="_blank"
                                                    class="txt_link"
                                                >
                                                    {{ file.FILE_NM }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div class="btn_wrap" v-if="$route.name !== 'newQuestionConnect'">
                                <a
                                    href="javascript:"
                                    class="btn_laodmore"
                                    @click="search(0)"
                                    v-if="qnaCurrentRecords < qnaTotalRecords"
                                >
                                    {{ $t('BUTTON.SEARCH.LOAD.MORE') }}
                                    <em>
                                        (<i>{{ qnaCurrentRecords }}</i> / {{ qnaTotalRecords }})
                                    </em>
                                </a>
                                <a
                                    href="javascript:"
                                    class="txt_link"
                                    @click="register()"
                                    v-if="!getIsMobile && searchYn && ((0 === qnaTotalRecords && searchYn) || viewYn)"
                                >
                                    {{ $t('MESSAGE.FAQ.CREATE') }}
                                </a>
                            </div>
                        </div>
                        <div class="faq_wrap" v-else>
                            <ul class="faq_list">
                                <li class="nodata">
                                    <span>{{ $t('MESSAGE.GLOBAL.NO.DATA') }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import moment from 'moment';
import { SDLUtil, MenuUtil } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/utils/EventBus';
import api from '@/service';
import InnorixDownload from '~c/InnorixDownload';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import DatePicker from '~c/DatePicker';
import createNewQuestionPopup from '~vb/faq/popup/createNewQuestionPopup';

require('moment-jdateformatparser');

export default {
    name: 'newQuestionList',
    components: {
        'innorix-download': InnorixDownload,
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    data() {
        return {
            faqPageName: 'viewFAQ',
            qnaPageName: 'newQuestionList',
            pageTitle: '',
            faqCurrentPage: 1,
            faqTotalRecords: -1,
            faqCurrentRecords: 0,
            qnaCurrentPage: 1,
            qnaTotalRecords: -1,
            qnaCurrentRecords: 0,
            nRecordsPerPage: Number(localStorage.getItem('listRows')),
            faqList: [],
            qnaList: [],
            searchFrAddDt: '',
            searchToAddDt: '',
            inquiry1Code: '',
            inquiry2Code: '',
            category1Code: '',
            category2Code: '',
            category1CodeList: [],
            category2CodeList: [],
            searchTitle: '',
            searchKeyword: '',
            // gradeCode: '',
            // gradeCodeList: [],
            faqAttach: [],
            qnaAttach: [],
            serviceType: 'common',
            viewYn: false,
            searchYn: false,
            noCntYn: false,
            open: false,
            isSurvey: '',
        };
    },
    created() {
        this.categoryList(1);
    },
    mounted() {
        let toDate = new Date();
        let frDate = new Date();
        frDate.setDate(frDate.getDate() - 7);

        // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'fr-picker-container',
            'frDate',
            'icoFrDate',
            'to-picker-container',
            'toDate',
            'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            frDate,
            toDate,
        );

        setTimeout(() => {
            if (!SDLUtil.isNull(this.category1CodeList[0].code)) {
            	this.category1Code = this.category1CodeList[0].code;
            }
            this.search(1);
        }, 500);
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            loginSystem: 'getLoginSystem',
            corpCd: 'getCorpCd',
            supportSnb: 'getSupportSnb',
            supportSnbParams: 'getSupportSnbParams',
            menus: 'getMenus',
        }),
        getIsMobile() {
            return SDLUtil.isMobile() || '';
        },
    },
    watch: {
        supportSnbParams() {
            this.initializeSearch();
        },
    },
    methods: {
        ...mapActions(['setSupportSnbParams']),

        //function start
        //initialize start
        initializeSnbParams(faqInquiry1Code, faqInquiry2Code, faqCategory1Code, faqCategory2Code, type) {
            let saveSupportSnb = new Object();
            saveSupportSnb.faqInquiry1Code = SDLUtil.nvl(faqInquiry1Code);
            saveSupportSnb.faqInquiry2Code = SDLUtil.nvl(faqInquiry2Code);
            saveSupportSnb.faqCategory1Code = SDLUtil.nvl(faqCategory1Code);
            saveSupportSnb.faqCategory2Code = SDLUtil.nvl(faqCategory2Code);
            saveSupportSnb.faqType = SDLUtil.nvl(type);
            this.setSupportSnbParams(saveSupportSnb);
        },
        async initializeSearch() {
            if (SDLUtil.isNull(this.supportSnbParams.faqType)) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.categoryList(1);
            } else if ('I' === this.supportSnbParams.faqType) {
                this.inquiry1Code = this.supportSnbParams.faqInquiry1Code;
                this.inquiry2Code = this.supportSnbParams.faqInquiry2Code;
            } else if ('C' === this.supportSnbParams.faqType) {
                this.category1Code = this.supportSnbParams.faqCategory1Code;
                this.category2Code = this.supportSnbParams.faqCategory2Code;
                this.categoryList(1);
            }

            this.search(1);
        },
        //initialize end
        //search option start
        search(page) {
            if (page === 0) {
                if ($('.tab_wrap #tab_qna').hasClass('on')) {
                    this.qnaCurrentPage = Number(this.qnaCurrentPage) + 1;
                    this.qnaSearchList();
                } else {
                    this.faqCurrentPage = Number(this.faqCurrentPage) + 1;
                    this.faqSearchList();
                }
            } else {
                this.faqCurrentPage = page;
                this.qnaCurrentPage = page;
                this.faqSearchList();
                this.qnaSearchList();
            }
        },
        async faqSearchList() {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/faq/faqSearch.skp`,
                    qs.stringify({
                        page: this.faqCurrentPage,
                        nRecordsPerPage: this.nRecordsPerPage,
                        searchTitle: this.searchTitle,
                        searchKeyword: this.searchKeyword,
                        searchInquiryType1: this.inquiry1Code,
                        searchInquiryType2: this.inquiry2Code,
                        PRD_CATEGORY_CD1: this.category1Code,
                        PRD_CATEGORY_CD2: this.category2Code,
                        // PRD_CATEGORY_CD3: this.category3Code,
                        // EXCELLENT_GRADE: this.gradeCode,
                        systemId: this.loginSystem,
                    }),
                )
                .then(resp => {
                    this.searchYn = true;
                    if (this.faqCurrentPage === 1) {
                        this.faqList = resp.data.list.rowData;
                    } else {
                        for (let list of resp.data.list.rowData) {
                            this.faqList.push(list);
                        }
                    }

                    this.faqCurrentPage = resp.data.search.PAGING_CURR_PAGE;
                    this.faqTotalRecords = resp.data.search.totalRecords;
                    this.faqCurrentRecords =
                        Number(this.faqCurrentPage) * this.nRecordsPerPage > this.faqTotalRecords
                            ? this.faqTotalRecords
                            : Number(this.faqCurrentPage) * this.nRecordsPerPage;
                    SDLUtil.showLoadingBar(false);
                    EventBus.$emit('question-snb-status');
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async qnaSearchList() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            let startDate = this.rangePicker.getStartDate();
            let endDate = this.rangePicker.getEndDate();
            let searchFromDt = startDate ? moment(startDate).formatWithJDF(mFormat) : '';
            let searchToDt = endDate ? moment(endDate).formatWithJDF(mFormat) : '';
            if (parseInt((endDate - startDate) / (24 * 60 * 60 * 1000)) > 90) {
                SDLUtil.alert(SDLUtil.getMsgProp('MESSAGE.DATE.VALIDATION.DAY90'));
                return false;
            }

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/qna/qnaSearch.skp`,
                    qs.stringify({
                        page: this.qnaCurrentPage,
                        nRecordsPerPage: this.nRecordsPerPage,
                        searchTitle: this.searchTitle,
                        searchKeyword: this.searchKeyword,
                        searchInquiryType1: this.inquiry1Code,
                        searchInquiryType2: this.inquiry2Code,
                        PRD_CATEGORY_CD1: this.category1Code,
                        PRD_CATEGORY_CD2: this.category2Code,
                        systemId: this.loginSystem,
                        loginNo: this.loginNo,
                        addedDateStart: searchFromDt,
                        addedDateEnd: searchToDt,
                    }),
                )
                .then(resp => {
                    this.searchYn = true;
                    if (this.qnaCurrentPage === 1) {
                        this.qnaList = resp.data.result.rowData;
                    } else {
                        for (let list of resp.data.result.rowData) {
                            this.qnaList.push(list);
                        }
                    }

                    this.qnaCurrentPage = resp.data.search.PAGING_CURR_PAGE;
                    this.qnaTotalRecords = resp.data.search.totalRecords;
                    this.qnaCurrentRecords =
                        Number(this.qnaCurrentPage) * this.nRecordsPerPage > this.qnaTotalRecords
                            ? this.qnaTotalRecords
                            : Number(this.qnaCurrentPage) * this.nRecordsPerPage;
                    this.isSurvey = resp.data.search.isSurvey;
                    // console.log(this.isSurvey);
                    SDLUtil.showLoadingBar(false);
                    EventBus.$emit('question-snb-status');
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async faqSearchDetail(v) {
            SDLUtil.showLoadingBar(false);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/faq/faqDetail.skp`, qs.stringify({ FAQ_ID: v }))
                .then(resp => {
                    this.faqAttach = resp.data.attach.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async qnaSearchDetail(v) {
            SDLUtil.showLoadingBar(false);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/myKnowledge/myQnA/myQuestion/detailPopupView.skp`,
                    qs.stringify({ questionId: v }),
                )
                .then(resp => {
                    this.qnaAttach = resp.data.attach.rowData;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        //search option end

        //search area start
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1CodeList = [];
                this.category2CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category1CodeList = resp;
                    this.categoryList(2);
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2CodeList = [];
                let code = this.category2Code;
                await this.getCodeComboList(parentCode, codeCategoryId).then(resp => {
                    this.category2CodeList = resp;
                    const idx = resp.findIndex(function(item) {
                        return item.code === code;
                    });
                    if (0 > idx) {
                        this.category2Code = '';
                    }
                });
            }
        },
        //search area end

        //page move start
        register(tab, v) {
            if ('faq' === tab && SDLUtil.nvl(v)) {
                return this.$router.push({
                    path: this.menuCommit('FAQ', 'Create New FAQ', '/basis/faq/faqForm'),
                    query: { faq_id: SDLUtil.nvl(v) },
                });
            } else if ('qna' === tab && SDLUtil.nvl(v)) {
                return this.$router.push({
                    path: this.menuCommit('Q&A', 'Create New Question', '/basis/qna/createNewQuestion'),
                    query: { questionId: SDLUtil.nvl(v) },
                });
            // } else if (this.isSurvey) {
            //     return this.$router.push({
            //         path: this.menuCommit('Q&A', 'Q&A List', '/skp/basis/myKnowledge/myQnA/myQuestion/myQuestionList'),
            //         query: { isSurvey: !SDLUtil.isNull(this.isSurvey) },
            //     });
            } else {
                return this.$router.push(this.menuCommit('Q&A', 'Create New Question', '/basis/qna/createNewQuestion'));
            }
        },
        menuCommit(menu, subMenu, conUrl) {
            for (const menus of this.menus) {
                for (const menu of menus.subMenu) {
                    let connUrl = menu.connUrl.replace('.skp', '');
                    if (conUrl === connUrl) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return connUrl;
                    }

                    if ('/basis/qna/createNewQuestion' === conUrl && '/basis/qna/newQuestionList' === connUrl) {
                        store.commit('PARAMS', { menuId: menu.menuId, creationYn: menu.creationYn });
                        return conUrl;
                    }
                }
            }

            return MenuUtil.getSupportMain();
        },
        //page move end

        //etc start
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.corpCd);
            return codeResp;
        },
        faqClick(e, v) {
            this.faqSearchDetail(v);
            this.viewYn = true;
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') === true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $('.faq .faq_list li').removeClass('active');
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        qnaClick(e, v) {
            this.qnaSearchDetail(v);
            this.viewYn = true;
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') === true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                $('.qna .faq_list li').removeClass('active');
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        getSnbClass(v) {
            let result = 'dir';
            let current = this.supportSnbParams.faqInquiry1Code;
            if ('ALL' === v) {
                result = 'active';
            } else {
                if (current === v) result += ' active';
            }
            return result;
        },
        snbClick(e, strA, strB, strC) {
            if ('ALL' === strA) strA = '';

            if (SDLUtil.isNull(strB)) {
                $('.list_03 > li > a').removeClass('active');
                $('.list_03 > li > .ico_arrow').removeClass('active');
                $(e.target).addClass('active');
            } else {
                $('.list_03 > li > ul > li > a').removeClass('active');
                $(e.target).addClass('active');
            }

            if ('arrow' === strC) return;

            this.initializeSnbParams(strA, strB, '', '', '');
        },
        getQuickCategoryClick(strC, strD) {
            let strA = this.supportSnbParams.faqInquiry1Code;
            let strB = this.supportSnbParams.faqInquiry2Code;
            this.initializeSnbParams(strA, strB, strC, strD, 'C');
        },
        getQuickName(strA, strB, strC) {
            let result = '';
            let ConnectionText = ' > ';
            if (!SDLUtil.isNull(strA)) {
                result += strA;
                if (!SDLUtil.isNull(strB)) {
                    result += ConnectionText + strB;
                    if (!SDLUtil.isNull(strC)) {
                        result += ConnectionText + strC;
                    }
                }
            }
            return result;
        },
        stripHtml(html) {
            var tmp = document.createElement('html');
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || '';
        },
        getDownloadUrl(SEQ, TOKEN) {
            let cmnApiBase = `${SDLUtil.API_URL}/basis/common/attachDownload.skp`;
            return cmnApiBase + '?attachFileSeq=' + SEQ + '&encToken=' + TOKEN;
        },
        tabClick(e, v) {
            $('.tab_menus li').removeClass('on');
            $('.tab_wrap .tab_cont').hide();
            $('.tab_wrap #tab_' + v).addClass('on');
            $('.tab_wrap .' + v).show();
            if ('faq' === v) {
                $('.srchTop_wrap').removeClass('open');
                this.open = false;
            } else if ('qna' === v) {
                $('.srchTop_wrap').addClass('open');
                this.open = true;
            }
        },
        srchBtmClick(e) {
            if ($('.srchTop_wrap').hasClass('extend') == true) {
                $('.srchTop_wrap').removeClass('extend');
                $(e.target).attr('title', 'Expand');
            } else {
                $('.srchTop_wrap').addClass('extend');
                $(this).attr('title', 'Fold');
            }
        },
        createNewQuestionPopup() {
            let params = {};
            SDLUtil.show(createNewQuestionPopup, params, {
                width: '500px',
                height: 'auto',
            });
            this.search(1);
            return this.$emit('close');
        },
        //etc end
        //function end
    },
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/qna/newQuestionList.vue